import type {MemexColumn, MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import type {PersistedOption} from '../../../api/columns/contracts/single-select'
import {BaseColumnModel} from './base'

export abstract class BaseMultiSelectColumnModel extends BaseColumnModel {
  declare readonly id: number
  declare readonly dataType: typeof MemexColumnDataType.MultiSelect
  declare readonly settings: {
    width: number
    options: Array<PersistedOption>
  }
  constructor(column: MemexColumn) {
    super({
      ...column,
      settings: {
        ...column.settings,
        options: column.settings?.options ?? [],
      },
    })
  }
}
